import { render, staticRenderFns } from "./EditDialog_Details.vue?vue&type=template&id=e01e389a"
import script from "./EditDialog_Details.vue?vue&type=script&lang=js"
export * from "./EditDialog_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports